var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFcPitch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 95 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 16V9.5L16 8L28.5 64L5 68L0 54.5H4V49.5L19 51.5C18.5194 46.5341 17.5 35 16.669 26.5C16.6141 26.1611 16.5578 25.8275 16.5 25.5C15 17 6 15.5 3 16Z",
    fill: "#0088E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 46L3 19.5C10.2 19.9 12.6667 24.3333 13 26.5L15 47.5L3.5 46Z",
    fill: "#0088E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46 3.5L19.5 7.5L32 63.5L44.5 61.5L43.5 53.5H47.5V47L46 46.8044C31 44 30.5 31 34 26L45 21L44.5 11H49L46 3.5Z",
    fill: "#0088E7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 43.5L45.5 24.5L36 29C35.9676 29.1684 35.9379 29.3351 35.9108 29.5C34.2635 39.5158 42.2369 43.0081 46.5 43.5Z",
    fill: "#0088E7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5 43L48.5 24.5C60 26.5 60 35.5 59 39L58 39.5L49.5 43Z",
    fill: "#0088E7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 64.5L46 57H50.5L50 46.5L61.6791 41.5C66 27 54.7579 21.6593 48 21L47.5 14.5H52L51 6.5L63.5 4.5L75.5 60.5L48.5 64.5Z",
    fill: "#0088E7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5 0L66.5 4L79 60L92 58V52.0322H91.5C81.5056 52.5481 78.664 44.9351 78.5 41L76.5 16.5L91 18.5V13.5L95 13L89.5 0Z",
    fill: "#0088E7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5 22L80 20.5C80.3333 23 81.1 29.5 81.5 35.5C81.9 41.5 82.1412 42.6667 82.2118 42.5C84.6975 48.0465 89.7331 48.8238 92 48.5L91.5 22Z",
    fill: "#0088E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFcPitch);
export default __webpack_public_path__ + "static/media/fc-pitch.2eee81b6790d52d97f03c0dd74f0feba.svg";
export { ForwardRef as ReactComponent };